<template>
  <div style="padding: 0 0 40px 0">
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true">
    </loading>
    <div class="container p-0" v-if="!isLoading">
      <div class="box-banner">
      </div>
      <h4 v-if="count" style="color:orange;padding-top: 25px;" class="text-center">
        <b>ชำระเงินสำเร็จแล้ว คุณได้รับ {{  count  }} สิทธิ์ </b>
      </h4>
      <h4 v-else style="color:orange;padding-top: 25px;" class="text-center">
        <b> ขออภัย คุณยังไม่ได้สิทธิ์ในการรับโชค </b>
      </h4>
      <p class="text-center">
        ประกาศรางวัลที่ <a href="https://www.facebook.com/horganice" target="_blank"> Facebook Fanpage </a> Horganice ระบบจัดการหอพัก อพาร์ทเม้นท์ <br>
        ในวันที่ 4 มีนาคม 2024 เวลา 17:00 น.
      </p>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "Home",
  data() {
    return {
      isLoading: false,
      count: 0
    };
  },
  components: {
    Loading,
  },
  async created() {
    try {
      if (
        this.$route.query &&
        this.$route.query.sessionToken
      ) {
        this.isLoading = true;
        this.count = await this.Track.getPaymentData(this.$route.query.sessionToken);
        this.isLoading = false;
      }
    } catch (error) {
      alert(error);
      console.log(error);
    }
    this.Track.getPaymentData()
  },
  methods: {
    // async clickInterest() {
    //   this.isLoading = true;
    //   window.open(
    //     "https://beneat.co/chat-booking?ref=s6nt9w",
    //     "_system",
    //     "location=yes"
    //   );
    //   try {
    //     if (
    //       this.$route.query &&
    //       this.$route.query.sessionToken &&
    //       this.$route.query.bannerId
    //     ) {
    //       await this.Track.click(
    //         "beneat-cleaning-interest-renter-app",
    //         this.$route.query.bannerId,
    //         this.$route.query.sessionToken
    //       );
    //     }
    //   } catch (error) {
    //     alert(error);
    //     console.log(error);
    //   }
    //    this.isLoading = false;
    // },
  },
};
</script>
<style scoped>
.box-banner {
  max-width: 700px;
  margin: 0 auto;
}

.box-banner img {
  width: 100%;
}

.t-head {
  font-size: 14px;
  border: 2px solid #eeab7f;
  padding: 8px 0;
  border-radius: 20px;
  background-color: #ff9853;
  color: white;
  font-weight: bold;
  box-shadow: 0px 3px 5px #00000036, 5px 15px 5px #ffffff23 inset;
}

.l-head {
  font-size: 14px;
  padding: 8px 0;
  border-radius: 10px;
  background-color: #b9dffa;
  font-weight: bold;
}

.l-head2 {
  font-size: 14px;
  padding: 8px 0;
  border-radius: 10px;
  background-color: #c4c7c9;
  font-weight: bold;
}

.b-right {
  border-right: 2px solid white;
}

.t-body {
  margin-top: 5px;
  font-size: 13px;
}

small {
  font-size: 11px;
}

.box-btn {
  position: sticky;
  background-color: white;
  padding: 10px 0 30px 0;
  bottom: 0;
  box-shadow: 0px -2px 2px #0000001d;
  margin-top: 30px;
}
</style>s